// extracted by mini-css-extract-plugin
export default {"CircleStat":"CircleStat_CircleStat__X3ONW","CircleStat--small-text":"CircleStat_CircleStat--small-text__GphXl"};